import { useCallback } from 'react'
import { useLocation } from 'wouter'

/**
 * Hook that provides navigation functions without subscribing to location changes.
 * This prevents unnecessary rerenders when the URL changes.
 */
export const useNavigation = () => {
  const [, setLocation] = useLocation()

  const navigate = useCallback((path: string) => {
    setLocation(path)
  }, [setLocation])

  const navigateWithParams = useCallback((path: string, params: Record<string, string>) => {
    const searchParams = new URLSearchParams(params)
    const queryString = searchParams.toString()
    setLocation(queryString ? `${path}?${queryString}` : path)
  }, [setLocation])

  return { navigate, navigateWithParams }
}